<template>
  <div class="login-box">
    <el-dialog :visible.sync="$store.state.app.dialogVisible" size="tiny" :before-close="hasClck">
      <!--登录-->
      <div class="login-star">
        <!--登录-->
        <div class="sign-box back_potion" v-show="$store.state.app.sin_login">
          <div class="sign-top pt10">
            <img src="/static/images/denlu.png?v=1.0" />
          </div>
          <div class="inpu-box">
            <div class="input-form input-select">
              <div class="select-num">
                <el-dropdown trigger="click" menu-align="start" @command="selse">
                  <span class="el-dropdown-link">
                    + {{nation_code}}
                    <img src="/static/images/jinjiantou.png" />
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      v-for="(item,index) in nation"
                      :command="item.nation_code"
                    >{{item.nation_code}}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <input placeholder="请输入手机号码" v-model="form.phone" type="tel" />
            </div>
            <div class="input-form">
              <input placeholder="请确认密码" v-model="form.password" @keyup.enter="loGin" type="password" />
            </div>
            <div class="send-btn margi-top23" @click="loGin">登录</div>
            <div class="send-btn new-closebtn" @click="show(3)">取消</div>
            <div class="sign-bottom">
              <div class="sign-bottom-left" @click="show(1)">
                <span>新用户注册</span>
              </div>
              <div class="sign-bottom-right" @click="show(2)">
                <span>忘记密码</span>
              </div>
            </div>
          </div>
        </div>
        <!--登录结束-->
        <!--注册页-->
        <div class="sign-box back_potion" v-show="$store.state.app.register">
          <div class="sign-top pt10">
            <img src="/static/images/denlu.png?v=1.0" />
          </div>
          <div class="inpu-box">
            <div class="input-form input-select">
              <div class="select-num">
                <el-dropdown trigger="click" menu-align="start" @command="selse">
                  <span class="el-dropdown-link">
                    + {{nation_code}}
                    <img src="/static/images/jinjiantou.png" />
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      v-for="(item,index) in nation"
                      :command="item.nation_code"
                    >{{item.nation_code}}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <input placeholder="请输入手机号码" v-model="form.phone" type="tel" />
            </div>
            <div class="input-form">
              <input placeholder="请输入短信验证码" v-model="form.code" type="text" />
              <span
                class="input-text"
                :class="{'gray':isGetCode || !form.phone}"
                v-html="timerMsg"
                @click="getCode(1)"
              ></span>
            </div>
            <div class="input-form">
              <input placeholder="请输入密码" type="password" v-model="form.password" />
            </div>
            <div class="input-form">
              <input placeholder="请再次输入密码" type="password" v-model="form.new_password" />
            </div>
          </div>
          <div class="send-btn margin_26" @click="register(1)">立即注册</div>
          <!-- <div class="checkout-box">
			<img v-if="!checkou" @click="checkou=true" src="/static/images/checko.png"/>
			<img @click="checkou=false" v-else src="/static/images/gou.png"/>
    
			<span @click="$store.state.app.registration=true" class="huise">《用户协议》</span>
          </div>-->
        </div>
        <!--注册页结束-->
        <!--忘记密码-->
        <div class="sign-box back_potion" v-show="$store.state.app.forget">
          <div class="sign-top pt20">
            <img src="/static/images/denlu.png" />
          </div>
          <div class="inpu-box">
            <div class="input-form input-select">
              <div class="select-num">
                <el-dropdown trigger="click" menu-align="start" @command="selse">
                  <span class="el-dropdown-link">
                    + {{nation_code}}
                    <img src="/static/images/jinjiantou.png" />
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      v-for="(item,index) in nation"
                      :command="item.nation_code"
                    >{{item.nation_code}}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <input placeholder="请输入手机号码" v-model="form.phone" type="text" />
            </div>
            <div class="input-form">
              <input placeholder="请输入短信验证码" type="text" v-model="form.code" />
              <span
                class="input-text"
                :class="{'gray':isGetCode || !form.phone}"
                v-html="timerMsg"
                @click="getCode(2)"
              ></span>
            </div>
            <div class="input-form">
              <input placeholder="请输入密码" type="password" v-model="form.password" />
            </div>
            <div class="input-form">
              <input placeholder="请再次输入密码" type="password" v-model="form.new_password" />
            </div>
          </div>
          <div class="send-btn margin_34" @click="register(2)">保存</div>
        </div>
        <!--忘记密码结束-->
      </div>
      <!--登录结束-->
      <!--充值页面-->
      <div class="weChat-pay">
        <div class="weChat-box" v-show="$store.state.app.weChat">
          <div class="title">请使用微信扫码支付</div>
          <div class="price-show">{{$store.state.app.mold.amount | toFixedPrice}}元</div>
          <!--:style="`background-image: url(${});`"-->
          <div
            class="QRcode"
            :style="`background-image: url(${$store.state.app.mold.wechat_url});`"
          ></div>
          <button class="btn" @click="closeTo()">已完成付款</button>
        </div>
        <!--支付宝-->
        <div class="alipay-box" v-show="$store.state.app.alPay">
          <div class="title">请在支付宝页面完成付款</div>
          <div class="desc">付款完成前请不要关闭此弹框</div>
          <a
            class="herf"
            :href="$store.state.app.mold.url"
            target="_blank"
            v-if="$store.state.app.goPay"
            @click="$store.state.app.goPay=false"
          >点击去支付宝支付</a>
          <div class="btn-boxalert" v-else>
            <button class="btn2 margin_25" @click="closeTo()">已完成付款</button>
            <button class="btn2" @click="closeTo(1)">支付失败</button>
          </div>
        </div>
      </div>
      <div class="alert-message" v-show="$store.state.app.msg">
        <div class="msg-img">
          <img src="/static/images/gantan.png" />
        </div>
        <div class="msg-alerttext">您已点赞该节目,谢谢</div>
      </div>
      <!--充值页面结束-->
    </el-dialog>
    <!--充值-->
    <div class="registration">
      <el-dialog :visible.sync="$store.state.app.registration" size="tiny" width="60%">
        <div class="registration-text">
          <iframe src="https://times.yourhr.com.cn/protocol/register_protocol.html" frameborder="0" width="100%" height="100%"></iframe>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import md5 from "../lib/md5";
import { Verify, LoginStatus } from "hanzi-vue-package";
import { Dialog, Dropdown, DropdownMenu, DropdownItem } from "element-ui";
import Vue from "vue";
Vue.use(Dialog);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
export default {
  data() {
    return {
      checkou: false,
      headimg: "",
      form: {
        phone: "",
        password: "",
        code: "",
        new_password: ""
      },
      nation_code: "86",
      nation: [],
      agreement: "",
      pay: true,
      herf: "",
      type_list: [],
      playType: 1,
      isGetCode: false,
      timerMsg: "获取验证码",
      qrcode: {
        amount: "",
        url: ""
      },
      URL: location.href
    };
  },
  props: {},
  computed: {},
  methods: {
    selse(res) {
      this.nation_code = res;
    },
    /*选择金额*/
    selectMoney(data, index) {
      for (let item of this.type_list) {
        item.active = false;
      }
      this.type_list[index].active = true;
    },
    hasClck() {
      this.show(3);
      this.countDown("over");
    },
    /*注册 找回密码*/
    register(type) {
      let that = this,
        ajaxData = {};
      let Url = "/api/register/pass/phone";
      if (type == 2) {
        Url = "/api/user/forget/passwords";
      }
      if (!that.form.phone) {
        tools.alert.error("请输入手机号码");
        return;
      }
      if (!/^1(3|4|5|7|6|8|9)\d{9}$/.test(that.form.phone)) {
        tools.alert.error("手机号码或密码错误");
        return;
      }
      if (!that.form.code) {
        tools.alert.error("请输入手机验证码");
        return;
      }
      if (!that.form.password) {
        tools.alert.error("请输入密码");
        return;
      }
      if (!that.form.new_password) {
        tools.alert.error("请输入确认密码");
        return;
      }
      if (that.form.new_password.toString().length < 6) {
        tools.alert.error("密码不能少于6位数");
        return;
      }
      if (that.form.password.toString().length < 6) {
        tools.alert.error("密码不能少于6位数");
        return;
      }
      console.log(that.form.new_password.length, "that.form.new_password");

      if (that.form.password != that.form.new_password) {
        tools.alert.error("两次输入密码不一致");
        return;
      }
      ajaxData.phone = that.form.phone;
      ajaxData.verification_code = that.form.code;
      ajaxData.password = md5(that.form.password);
      tools.alert.loading();
      tools.ajax({
        url: Url,
        ajaxData: ajaxData,
        successFun: function(res) {
          that.form.phone = "";
          that.form.password = "";
          that.form.code = "";
          that.form.new_password = "";
          that.show(6);
          that.countDown("over");
          tools.alert.closeLoading();
        },
        errorFun: function(error_data, status, headers, error_obj) {
          tools.alert.closeLoading();
          that.isGetCode = false;
          tools.alert.error(error_data.error_msg);
        },
        type: "POST"
      });
    },
    /*登录*/
    loGin() {
      let that = this,
        ajaxData = {};
      if (!that.form.phone) {
        tools.alert.error("请输入手机号码");
        return;
      }
      if (that.form.phone.indexOf(" ") >= 0) {
        tools.alert.error("手机号码或密码错误");
        return;
      }
      if (!/^1(3|4|5|7|6|8|9)\d{9}$/.test(that.form.phone)) {
        tools.alert.error("手机号码或密码错误");
        return;
      }
      if (!that.form.password) {
        tools.alert.error("请输入登录密码");
        return;
      }
      ajaxData.phone = that.form.phone;
      ajaxData.password = md5(that.form.password);
      tools.alert.loading();
      tools.ajax({
        url: "/api/logins",
        ajaxData: ajaxData,
        successFun: function(res) {
          that.personalMsg();
          that.show(3);
          tools.alert.closeLoading();
        },
        errorFun: function(error_data, status, headers, error_obj) {
          tools.alert.closeLoading();
          that.isGetCode = false;
          tools.alert.error(error_data.error_msg);
        },
        type: "POST"
      });
    },
    /*获取地区码*/
    getNation() {
      let that = this,
        ajaxData = {};
      tools.alert.loading();
      tools.ajax({
        url: "/api/nation/code",
        ajaxData: ajaxData,
        successFun: function(res) {
          that.nation = res.list;
          tools.alert.closeLoading();
        },
        errorFun: function(error_data, status, headers, error_obj) {
          tools.alert.closeLoading();
          that.isGetCode = false;
          tools.alert.error(error_data.error_msg);
        },
        type: "GET"
      });
    },
    /* 获取验证码 */
    getCode(type) {
      var that = this;
      if (!that.form.phone) {
        tools.alert.error("请输入手机号码");
        return;
      }
      let Url = "/api/register/sms";
      if (type == 2) {
        Url = "/api/user/forget/password/sms";
      }
      if (that.isGetCode) {
        return;
      }
      that.isGetCode = true;
      var ajaxData = {};
      if (!/^1(3|4|5|7|6|8|9)\d{9}$/.test(that.form.phone)) {
        tools.alert.error("手机号码或密码错误");
        return;
      }

      ajaxData.phone = Number(that.form.phone);
      //				ajaxData.type = type;
      tools.alert.loading();
      tools.ajax({
        url: Url,
        ajaxData: ajaxData,
        successFun: function(res) {
          tools.alert.closeLoading();
          that.countDown();
          tools.alert.success("验证码已发送");
        },
        errorFun: function(error_data, status, headers, error_obj) {
          tools.alert.closeLoading();
          that.isGetCode = false;
          tools.alert.error(error_data.error_msg);
        },
        type: "POST"
      });
    },
    countDown(msg) {
      var that = this;
      var p = {};
      p.num = 60;
      if (msg) {
        that.timerMsg = "获取验证码";
        that.isGetCode = false;
        clearInterval(that.time);
        return;
      }
      that.time = setInterval(function() {
        p.num--;
        if (p.num <= 0) {
          that.timerMsg = "重新获取";
          that.isGetCode = false;
          clearInterval(that.time);
        } else {
          that.timerMsg = p.num + "s";
        }
      }, 1000);
    },
    show(type) {
      let that = this;
      that.form.new_password = "";
      that.form.phone = "";
      that.form.code = "";
      that.form.password = "";
      switch (type) {
        case 1:
          that.$store.state.app.register = true;
          that.$store.state.app.forget = false;
          that.$store.state.app.sin_login = false;
          break;
        case 2:
          that.$store.state.app.register = false;
          that.$store.state.app.forget = true;
          that.$store.state.app.sin_login = false;
          break;
        case 3:
          that.$store.state.app.dialogVisible = false;
          setTimeout(function() {
            that.$store.state.app.msg = false;
            that.$store.state.app.register = false;
            that.$store.state.app.forget = false;
            that.$store.state.app.sin_login = false;
            that.$store.state.app.alPay = false;
            that.$store.state.app.weChat = false;
            that.$store.state.app.goPay = true;
            that.$store.state.app.pay = false;
            that.form.new_password = "";
            that.form.phone = "";
            that.form.code = "";
            that.form.password = "";
          }, 500);
          break;
        /*微信*/
        case 4:
          that.$store.state.app.register = false;
          that.$store.state.app.forget = false;
          that.$store.state.app.sin_login = false;
          that.$store.state.app.pay = false;
          that.$store.state.app.weChat = true;
          that.$store.state.app.alPay = false;
          break;
        /*支付宝*/
        case 5:
          that.$store.state.app.register = false;
          that.$store.state.app.forget = false;
          that.$store.state.app.sin_login = false;
          that.$store.state.app.pay = false;
          that.$store.state.app.weChat = false;
          that.$store.state.app.alPay = true;
          break;
        case 6:
          that.$store.state.app.sin_login = true;
          that.$store.state.app.forget = false;
          that.$store.state.app.register = false;
          that.$store.state.app.registration = false;
          break;
        default:
          break;
      }
    },
    /*个人信息*/
    personalMsg() {
      let that = this,
        ajaxData = {};
      tools.alert.loading();
      tools.ajax({
        url: "/api/users",
        ajaxData: ajaxData,
        successFun: function(res) {
          tools.cache.set("status", JSON.stringify(res.data));
          setTimeout(function() {
            that.$store.commit("GET_INFO");
          }, 20);
          // location.href = that.URL
          location.reload();
          // if(location.pathname !='/practice/test'){
          //     location.reload();
          // }
          tools.alert.closeLoading();
        },
        errorFun: function(error_data, status, headers, error_obj) {
          tools.alert.closeLoading();
          tools.alert.error(error_data.error_msg);
        },
        type: "GET"
      });
    },
    /*发送客服*/
    Customer() {
      if (!JSON.parse(tools.cache.get("status"))) {
        return;
      }
      let that = this,
        ajaxData = {};
      tools.ajax({
        url: "/api/users",
        ajaxData: ajaxData,
        successFun: function(res) {
          let plenmr = res.data;
          let sex;
          if (plenmr.sex == 1) {
            sex = "男";
          } else if (plenmr.sex == 2) {
            sex = "女";
          } else if (plenmr.sex == 0) {
            sex = "保密";
          }
          _MEIQIA("metadata", {
            name: plenmr.username, // 美洽默认字段
            gender: sex,
            tel: plenmr.phone,
            avatar: plenmr.headimg
          });
          tools.alert.closeLoading();
        },
        errorFun: function(error_data, status, headers, error_obj) {
          tools.alert.closeLoading();
          tools.alert.error(error_data.error_msg);
        },
        type: "GET"
      });
    },
    /*礼物充值价格类型*/
    moneyType() {
      if (!JSON.parse(tools.cache.get("status"))) {
        return;
      }
      let that = this,
        ajaxData = {};
      tools.alert.loading();
      tools.ajax({
        url: "/api/recharge/types",
        ajaxData: ajaxData,
        successFun: function(res) {
          for (let item of res.list) {
            item.active = false;
          }
          res.list[0].active = true;
          that.type_list = res.list;
          tools.alert.closeLoading();
        },
        errorFun: function(error_data, status, headers, error_obj) {
          tools.alert.closeLoading();
          tools.alert.error(error_data.error_msg);
        },
        type: "GET"
      });
    },
    /*充值*/
    Prepaid() {
      let type_id;
      let that = this;
      let Url = "/api/alipay/recharge";
      let device = "wap";
      if (that.playType == 2) {
        Url = "/api/wechatpay/recharge";
        device = "native";
      }
      let ajaxData = {};

      ajaxData.type_id = type_id;
      ajaxData.device = device;
      tools.alert.loading();
      tools.ajax({
        url: Url,
        ajaxData: ajaxData,
        successFun: function(res) {
          if (that.playType == 1) {
            that.herf = res.data.url;
            that.show(5);
          } else {
            that.qrcode = res.data;
            that.show(4);
          }

          tools.alert.closeLoading();
        },
        errorFun: function(error_data, status, headers, error_obj) {
          tools.alert.closeLoading();
          tools.alert.error(error_data.error_msg);
        },
        type: "POST"
      });
    },
    getAddress(completion) {
      let that = this;
      let ajaxData = {};
      const store = this.$store;
      const userId = store.state.app.data.id;

      tools.alert.loading();
      console.log("begin fetch address");
      tools.ajax({
        url: "/newApi/user/address/" + userId,
        ajaxData: ajaxData,
        timeout: 10000,
        successFun: function(res) {
          console.log("fetch address success, res:", res);
          if (res.data && res.data.length > 0) {
            completion(true);
          } else {
            completion(false);
          }
          tools.alert.closeLoading();
        },
        errorFun: function(error_data, status, headers, error_obj) {
          tools.alert.closeLoading();
          tools.alert.error(error_data.error_msg);
          console.log("fetch address fail, error_msg:", error_data.error_msg);
          completion(false);
        },
        type: "GET"
      });
    },
    checkCourseGiftAddress(course_id) {
      let that = this;
      const courseId = course_id;
      const is_gift = this.$store.state.app.pay_course_gift;
      if (!is_gift) {
        that.toUrl("/personal/culum");
        return;
      }
      this.getAddress(function(result) {
        if (result != true) {
          layer.confirm(
            "该课程包含赠品，是否立刻填写收货地址？",
            {
              btn: ["确认", "取消"]
            },
            function(index) {
              layer.close(index);
              that.toUrl("/personal/index", { type: 6 });
            },
            function(index) {
              layer.close(index);
              that.toUrl("/personal/culum");
            }
          );
        } else {
          that.toUrl("/personal/culum");
        }
      });
    },
    /*完成付款操作*/
    closeTo(index) {
      let that = this;
      that.show(3);
      if (index) {
        return;
      }

      const course_id = this.$store.state.app.pay_course_id;
      if (this.$store.state.app.pay_type == 1) {
        window.history.go(-1);
      } else if (course_id) {
        this.checkCourseGiftAddress(course_id);
      } else {
        that.toUrl("/personal/culum");
      }
    },
    /*注册协议*/
    getAgreement() {
      let that = this;
      let ajaxData = {};
      tools.alert.loading();
      tools.ajax({
        url: "/api/register/protocol",
        ajaxData: ajaxData,
        successFun: function(res) {
          that.agreement = res.data.content;
          tools.alert.closeLoading();
        },
        errorFun: function(error_data, status, headers, error_obj) {
          tools.alert.closeLoading();
          tools.alert.error(error_data.error_msg);
        },
        type: "GET"
      });
    }
  },
  components: {},
  filters: {},
  watch: {},
  mounted() {
    console.log(this.URL, "123456");
    this.getNation();
    //			this.moneyType();
    // this.getAgreement();
    this.Customer();
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
@import "../assets/sass/Loginr.scss";
.registration-text {
  height: 600px;
}
</style>



// WEBPACK FOOTER //
// Loginr.vue?9838ee2e